import axios from 'axios'
import CONFIG from '@/config'

import { Storage } from '@aws-amplify/storage'

import bus from '@/eventbus'
import store from '@/store/index'

const BASE_URL = CONFIG.API_PATH

const BUCKET = CONFIG.Storage.AWSS3.bucket
const BUCKET_REGION = CONFIG.Storage.AWSS3.region

const S3_URL = `https://${BUCKET}.s3-${BUCKET_REGION}.amazonaws.com/public`


async function setAuthHeader() {
	await store.dispatch('getSession')

	Storage.configure({
		customPrefix: {
			public: 'public/'
		}
	})
}

const FileService = {
	get: async page => {
		const URL = `${BASE_URL}/${page}`
		let result = await axios.get(URL)
		return result.data
	},
	getS3Path(file) {
		return `${S3_URL}/${file}`
	},
	uploadS3: async (name, file) => {


		const filetype = file.type
		const filesize = file.size / 1000 // convert bytes to megabytes

		try {
			// Make sure AWS Credentials are loaded
			await setAuthHeader()

			let result = await Storage.put(file.name, file)
			const { key } = result

			// Get filepath
			const path = `${S3_URL}/${key}`

			const savedFile = { name, path, filetype, filesize }
			return savedFile
		} catch (error) {
			throw error
		}
	},
	deleteS3: async (key) => {
		try {
			setAuthHeader()
			let result = await Storage.remove(key)
			return result
		} catch (error) {
			bus.$emit('network-error', error)
		}
	}
}

export default FileService
